module.exports = __webpack_public_path__ + "img/projecto-4.8d28a69a.png";